var _a;
import { createActions } from 'redux-actions';
export var selectLanguage = (_a = createActions('SELECT_LANGUAGE', 'SELECT_LANGUAGE_COMPLETE'), _a.selectLanguage), selectLanguageComplete = _a.selectLanguageComplete;
